import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import InfluencerDetailsHeader from './InfluencerDetailsParts/InfluencerDetailsHeader'
import Textarea from '../../../../../FormComponents/Textarea'
import ReportInfluencerPerformance from '../../../../../../models/ReportInfluencerPerformance'
import ActionContentReview from './InfluencerDetailsParts/ActionContentReview'
export default observer(function InfluencerDetails({ infActions, formProps, performance, pmSide }) {
  const { values, setFieldValue, handleBlur, handleChange } = formProps || {}
  const [freeText, setFreeText] = useState(null)
  
  useEffect(() => {
    if (!values || !infActions) return

    if (infActions && infActions.length > 0) {
      const existingFreeText = values.report_influencer_performances_attributes.find(
        p => p.influencer_id === infActions[0].influencer_id && !p._destroy
      )
      
      if (existingFreeText) {
        setFreeText(existingFreeText)
      } else {
        const newFreeText = new ReportInfluencerPerformance({
          influencer_id: infActions[0].influencer_id,
          free_text: '',
        })
        
        setFieldValue('report_influencer_performances_attributes', [
          ...values.report_influencer_performances_attributes, 
          newFreeText
        ])
        
        setFreeText(newFreeText)
      }
    }
  }, [infActions, values?.report_influencer_performances_attributes, setFieldValue])

  const index = values && values.report_influencer_performances_attributes.findIndex(
    p => p.influencer_id === infActions[0]?.influencer_id && !p._destroy
  )
  
  const updateFreeText = (event) => {
    // Extract the value from the event object if it's an event
    const value = event && event.target ? event.target.value : event
    
    if (index !== -1) {
      setFieldValue(`report_influencer_performances_attributes[${index}].free_text`, value)
      
      // Also update the local state to keep UI in sync
      if (freeText) {
        setFreeText({
          ...freeText,
          free_text: value
        })
      }
    } else {
      console.error("Free text not found after creation")
    }
  }

  if (!performance && !freeText) return null

  return (
    <div className='border-1 border-border-primary dark:border-rb-dark-mode-lighter rounded-lg'>
      <InfluencerDetailsHeader infActions={infActions} />
      <div className="py-4 px-5">
        {performance ? (
          <div>
            <h2 className='font-bold text-sm py-2 dark:text-white'>Influencer write-up</h2>
            <p className='dark:text-gray-400'>{performance.free_text}</p>
          </div>
        ) : (
          <Textarea
            className={`rounded-lg px-4 w-full`}
            rows={4}
            label="Free text"
            placeholder="Write something here"
            name={`report_influencer_performances_attributes.${index}.free_text`}
            onChange={updateFreeText}
            onBlur={handleBlur}
            value={freeText.free_text}
          />
        )}
      </div>
      { infActions.map(action => (
        <div key={action.id} className="py-4 px-5">
          <ActionContentReview action={action} pmSide={pmSide || false} />
        </div>
      ))}
    </div>
  )
})